import { IBedExitsRepository } from "../../adapters/driven/repositories/bedExitsRepository";

export const BedExitsServiceImplFactory = ({
  bedExitsRepository,
}: {
  bedExitsRepository: IBedExitsRepository;
}) => {
  const updateBedExits: IUpdateBedExitsAPI = async (payload) => {
    try {
      const response = await bedExitsRepository.UpdateBedExitsAPI(payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };
  const updateBedExitsTime: IUpdateBedExitsTimesAPI = async (payload) => {
    try {
      const response = await bedExitsRepository.UpdateBedExitsTimesAPI(payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const addBedExits: IAddBedExitsService = async (payload) => {
    try {
      const response = await bedExitsRepository.AddBedExitsAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const addBedExitsV3: IAddBedExitsAPIV3Service = async (
    payload,
    clinic_id
  ) => {
    try {
      const response = await bedExitsRepository.AddBedExitsAPIv3API(
        payload,
        clinic_id
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateNotificationFromPatientChart: IUpdateNotificationSettingsFromPatientChartAPI =
    async (payload) => {
      try {
        const response =
          await bedExitsRepository.UpdateNotificationFromPatientChartAPI(
            payload
          );
        return {
          success: true,
          data: response as unknown as IUpdateNotificationSettingsFromPatientChartAPIResponse,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const updateNotificationFromPatientChartV2: IUpdateNotificationSettingsFromPatientChartAPIv2 =
    async (payload) => {
      try {
        const response =
          await bedExitsRepository.UpdateNotificationFromPatientChartAPIv2(
            payload
          );
        return {
          success: true,
          data: response as unknown as IUpdateNotificationSettingsFromPatientChartAPIResponse,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const deleteBedExits: IDeleteBedExitsAPI = async (payload) => {
    try {
      const response = await bedExitsRepository.DeleteBedExitsAPI(payload);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const updateCombineBedExitsService: IUpdateNotificationSettingsFromPatientChartAPI =
    async (payload) => {
      try {
        const response = await bedExitsRepository.UpdateCombineBedExitsAPI(
          payload
        );
        return {
          success: true,
          data: response as unknown as IUpdateNotificationSettingsFromPatientChartAPIResponse,
        };
      } catch (error) {
        return {
          success: false,
          error: { message: (error as unknown as Error).message },
        };
      }
    };

  const getBedExitSettingsByUserPref: IBedExitSettingsService = async (
    payload
  ) => {
    try {
      const response = await bedExitsRepository.GetBedExitSettingByUserPrefAPI(
        payload
      );
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: {
          message: error instanceof Error ? error.message : "Unknown error",
        },
      };
    }
  };

  const getBedExitEventList: IBedExitEventListService = async (payload) => {
    try {
      const response = await bedExitsRepository.GetBedExitEventList(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: {
          message: error instanceof Error ? error.message : "Unknown error",
        },
      };
    }
  };

  const getBedExitFacilityReportService: IPostBedExitFacilityReportService =
    async (payload) => {
      try {
        const response = await bedExitsRepository.GetBedExitFacilityReportAPI(
          payload
        );
        return {
          success: true,
          data: response,
        };
      } catch (error) {
        return {
          success: false,
          error: {
            message: error instanceof Error ? error.message : "Unknown error",
          },
        };
      }
    };

  return {
    addBedExits,
    updateBedExits,
    deleteBedExits,
    getBedExitSettingsByUserPref,
    updateBedExitsTime,
    updateNotificationFromPatientChart,
    getBedExitEventList,
    updateCombineBedExitsService,
    getBedExitFacilityReportService,
    updateNotificationFromPatientChartV2,
    addBedExitsV3,
  };
};
